export default "__VITE_ASSET__0b34fdc5__"